module.exports = __webpack_public_path__ + "static/media/legend.7fedee56.png";